import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useNewUpdateCta } from '#src/app/pages/petitionDetails/shared/hooks';

export const NewUpdateCtaContainer: React.FC<EmptyProps> = () => {
	const {
		data: { canEdit, updateHref },
	} = useNewUpdateCta();

	if (!canEdit) return null;

	return (
		<div className="border-fill-information-weaker bg-fill-information-weaker my-4 rounded-md border p-4">
			<div className="flex flex-row-reverse sm:flex-col md:flex-row-reverse md:items-center">
				<Text as="div" size="small" className="mb-0 sm:mb-2 md:mb-0">
					<Translate value="fe.components.updates_feed.post_description" />
				</Text>
				<div className="flex-1 p-2 sm:flex-none sm:p-0 md:p-2">
					<Button
						as="a"
						href={updateHref}
						variant="secondary-solid"
						size="small"
						className="w-full"
						data-qa="petition-updates-new-update-cta"
					>
						<Translate value="fe.components.updates_feed.post_button" />
					</Button>
				</div>
			</div>
		</div>
	);
};
